module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowDown.8c228dc4.svg";